import config, {axiosConfig} from "../config";
import {AxiosRequestConfig} from 'axios';
import {default as axios} from "./axiosConfig";
import {IVehicleIdentificationCodeRequest, IVehicleIdentificationCodeResponse} from "../model/vehicle";
import {Country} from "../model/country";

export async function getVehicleBrands() {
    const {data} = await axios.get(`${config.API_URL}/vehicle/brand`, axiosConfig);
    return data;
}

export async function getVehicleModelsByBrand(brandName: string) {
    const {data} = await axios.get(`${config.API_URL}/vehicle/brand/${brandName}/model`, axiosConfig);
    return data;
}

export async function searchCity(query: string, size: number = 20) {
    const configParams: AxiosRequestConfig = {
        params: {
            query,
            page: 0,
            size
        }
    };

    const requestConfig: AxiosRequestConfig = {
        ...axiosConfig,
        ...configParams
    };

    const {data} = await axios.get(`${config.API_URL}/vehicle/search-city`, requestConfig);
    return data;
}

export async function getResidentCountries() {
    const {data} = await axios.get(`${config.API_URL}/vehicle/country`, axiosConfig);
    (data as Country[]).sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });

    return data;
}

export async function searchVehicle(plateNumber: string) {
    let axiosResponse = await axios.get(`${config.API_URL}/vehicle/search-by-plate-number/${plateNumber}`, axiosConfig);
    return axiosResponse;
}

export const searchVehiclesByPhoneAndBirthdate = async (request: IVehicleIdentificationCodeRequest): Promise<IVehicleIdentificationCodeResponse> => {
    const {data} = await axios.post<IVehicleIdentificationCodeResponse>(`${config.API_URL}/vehicle/find-vehicles-and-send-code`, request, axiosConfig);

    return data;
}

export const verifyVehiclesByPhoneAndBirthdate = async (request: IVehicleIdentificationCodeRequest): Promise<IVehicleIdentificationCodeResponse> => {
    const {data} = await axios.post<IVehicleIdentificationCodeResponse>(`${config.API_URL}/vehicle/find-vehicles-and-verify-code`, request, axiosConfig);

    return data;
}